import { z } from "zod/v4";

import { AiSelectorSearchTypeList } from "../../../schemas/ai/ai-old";

export const AiGetSelectorChatCompletionResponseSchema = z.object({
  selector: z.string(),
});
export type AiGetSelectorChatCompletionResponseType = z.infer<
  typeof AiGetSelectorChatCompletionResponseSchema
>;

export const AiGetSelectorResponseBodySchema =
  AiGetSelectorChatCompletionResponseSchema.extend({
    sessionId: z.string(),
  });

export type AiGetSelectorResponseBodyType = z.infer<
  typeof AiGetSelectorResponseBodySchema
>;

export const AiGetSelectorRequestBodySchema = z.object({
  html: z.string(),
  custom: z.string().nullish(),
  single: z.boolean().nullish(),
  find: z.enum(AiSelectorSearchTypeList).nullish(),
});

export type AiGetSelectorRequestBodyType = z.infer<
  typeof AiGetSelectorRequestBodySchema
>;
